import React from "react";
import {
  AreaChart as Chart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { CustomBarTooltip } from "./customToolTip/CustomToolTip";
import useScreenHook from "../../../utils/helperFunctions/useScreenHook";
import NoDataComponent from "../NoDataComponent";
import { format } from "d3-format";

export default function AreaChart(props: any) {
  const { rawData } = props;
  const { data, chartSetting = [], stackedMode=false } = rawData;

  const { deviceType = "desktop" } = useScreenHook();
  if (!data || !data.length) {
    return (
      <div className="h-[80%] pr-1.5 w-full flex justify-center">
        <NoDataComponent /> 
      </div>
    );
  }
  return (
    <div className="h-[83%] pr-1.5 w-full flex justify-center">
      <ResponsiveContainer width="100%" height="100%">
        <Chart
          data={data}
          margin={{
            top: 5,
            left: deviceType === "desktop" ? 0 : -25,
            bottom: 45,
            right: 30,
          }}
        >
          <CartesianGrid
            vertical={false}
            horizontal={true}
            strokeWidth={1}
            stroke={"#EAEAEA"}
          />
          <XAxis
            dataKey="pubDate"
            axisLine={false}
            tick={true}
            angle={-75}
            tickLine={true}
            tickMargin={35}
            tickSize={8}
            padding={{ left: deviceType === "desktop" ? 10 : 0, right: 5 }}
            // tick={<CustomizedLabel/>}
            className="md:text-[16px] text-[9px]"
          />
          <YAxis
            axisLine={false}
            tick={true}
            tickLine={false}
            tickMargin={deviceType === "desktop" ? 8 : 0}
            tickFormatter={(value) => `$${format(".2s")(value)}`}
            // tick={<CustomizedLabel/>}
            className="md:text-[16px] text-[9px]"
          />
          <Tooltip content={<CustomBarTooltip stackedMode={stackedMode}/>} cursor={false} />
          {chartSetting && chartSetting?.length
            ? chartSetting?.map((item: any, index: number) => (
                <Area
                  key={index + item.fill}
                  type="monotone"
                  dataKey={item.dataKey}
                  stackId="1"
                  stroke={item.fill}
                  fill={item.fill}
                  unit={item.label}
                />
              ))
            : null}
        </Chart>
      </ResponsiveContainer>
      <style>{`
      tspan{
      font-size: 11px;
      }
      `}</style>
    </div>
  );
}
